import React from "react";
import Spinner from "../../components/Spinner/index";

const SpinnerContainer = () => {
    return (
        <Spinner />
    )
}

export default SpinnerContainer;